import React, { useEffect, useState } from 'react';
import axios from 'axios';
import MasterNavbar from '../components/layout/MasterNavbar';
import { useNavigate } from 'react-router-dom';
import { toast, Toaster } from 'react-hot-toast';
import {
  DISTRIBUTOR_LIST_ENDPOINT,
  DELETE_DISTRIBUTOR_ENDPOINT
} from '../utils/api';

function DistributorsShow() {
  const [distributors, setDistributors] = useState([]);
  const navigate = useNavigate();

  const fetchDistributors = () => {
    const token = localStorage.getItem('token');

    axios.post(DISTRIBUTOR_LIST_ENDPOINT, { token }) // ✅ Send token in body
      .then(res => {
        if (res.data.success) {
          setDistributors(res.data.distributors || []);
        } else {
          toast.error(res.data.message || 'Failed to load distributors');
        }
      })
      .catch(() => toast.error('Failed to load distributors'));
  };

  useEffect(() => {
    fetchDistributors();
  }, []);

  const handleAdd = () => {
    navigate('/distributors/add');
  };

  const handleEdit = (id, distributor_token) => {
    navigate(`/distributors/edit/${id}/${distributor_token}`);
  };

  const handleDelete = async (id, distributor_token) => {
    if (!window.confirm("Are you sure you want to delete this distributor?")) return;

    try {
      const res = await axios.post(DELETE_DISTRIBUTOR_ENDPOINT, {
        id,
        distributor_token
      });
      if (res.data.success) {
        toast.success('Distributor deleted');
        fetchDistributors();
      } else {
        toast.error(res.data.message || 'Delete failed');
      }
    } catch {
      toast.error('Server error during delete');
    }
  };

  return (
    <>
      <MasterNavbar />
      <Toaster position="top-center" />
      <div className="container mt-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4>🏢 Distributors</h4>
          <button className="btn btn-success" onClick={handleAdd}>
            ➕ Add Distributor
          </button>
        </div>

        <div className="table-responsive">
          <table className="table table-bordered table-hover align-middle">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>City</th>
                <th>State</th>
                <th>GST No</th>
                <th>PAN No</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {distributors.length === 0 ? (
                <tr>
                  <td colSpan="7" className="text-center">No distributors found.</td>
                </tr>
              ) : (
                distributors.map((d, index) => (
                  <tr key={d.id}>
                    <td>{index + 1}</td>
                    <td>{d.name}</td>
                    <td>{d.city}</td>
                    <td>{d.state}</td>
                    <td>{d.gst_no}</td>
                    <td>{d.pan_no}</td>
                    <td>
                      <div className="d-flex gap-2">
                        <button className="btn btn-primary btn-sm" onClick={() => handleEdit(d.id, d.distributor_token)}>Edit</button>
                        <button className="btn btn-danger btn-sm" onClick={() => handleDelete(d.id, d.distributor_token)}>Delete</button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default DistributorsShow;
